import { Observable } from 'rxjs';
import { ValidaEdicionResponse } from 'src/app/global/interfaces/valida-edicion-paso-tres-response';


export abstract class ValidacionEdicionServiceVM {

  getValidacion$: Observable<boolean>;

  abstract setValidaStatus(valor: boolean): void;

  abstract getValidacionEdicion(): Observable<ValidaEdicionResponse>;


}
